import React, { useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import BannerCalculator from '../components/BannerCalculator';
import CalculatorTransaction from '../components/CalculatorTransaction';
import DiscountCalculator from '../components/DiscountCalculator';
import DiscountCalculatorTwo from '../components/DiscountCalculatorTwo';
import DiscountCalculatorThree from '../components/DiscountCalculatorThree';
import data from '../data/Calculadora.json';
import CalculatorAbout from '../components/CalculatorAbout';
import CalculatorBonifications from '../components/CalculatorBonifications';
import BannerCalculatorTwo from '../components/BannerCalculatorTwo';
import CalculatorSpecifications from '../components/CalculatorSpecifications';

const Calculadora = () => {
    const { id } = useParams();
    const productData = data.find((product) => product.id === id);

    const [tasaDescuento, setTasaDescuento] = useState(0);
    const [totalFinalTwo, setTotalFinalTwo] = useState(0);

    if (!productData) {
        return <Navigate to="/404" />;
    }

    return (
        <div className={`${productData.id}-page product-page`}>
            <BannerCalculator data={productData.welcome[0]} />
            <CalculatorSpecifications data={productData.technicalSpecifications} />
            <CalculatorTransaction data={productData.bannerGtapp[0]} />
            <CalculatorAbout data={productData.technicalSpecificationsTwo} />
            <CalculatorBonifications data={productData.calculatorBonifications[0]} />
            <BannerCalculatorTwo data={productData.bannerCalculatorThree[0]} />
            <DiscountCalculator setTasaDescuento={setTasaDescuento} />
            <DiscountCalculatorTwo tasaDescuento={tasaDescuento} setTotalFinalTwo={setTotalFinalTwo} />
            <DiscountCalculatorThree tasaDescuento={tasaDescuento} totalFinalTwo={totalFinalTwo} />
        </div>
    );
};

export default Calculadora;
